import styled from 'styled-components'
import theme from '../../styles/theme'

const StyledBox = styled.div`
  padding: 1.5rem;
  margin: 0 0 1rem 0;
  background: ${theme.color.bgShade};
  border-left: 4px solid ${theme.color.border};
`

export { StyledBox }
